import { render } from "./BaseLayoutComp.vue?vue&type=template&id=78153007"
import script from "./BaseLayoutComp.vue?vue&type=script&lang=js"
export * from "./BaseLayoutComp.vue?vue&type=script&lang=js"

import "./BaseLayoutComp.vue?vue&type=style&index=0&id=78153007&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__